const transactionConstants = {
  ADD_REQUEST: 'TRANSACTIONS_ADD_REQUEST',
  ADD_SUCCESS: 'TRANSACTIONS_ADD_SUCCESS',
  ADD_FAILURE: 'TRANSACTIONS_ADD_FAILURE',

  GET_PRICE_REQUEST: 'TRANSACTIONS_GET_PRICE_REQUEST',
  GET_PRICE_SUCCESS: 'TRANSACTIONS_GET_PRICE_SUCCESS',
  GET_PRICE_FAILURE: 'TRANSACTIONS_GET_PRICE_FAILURE',

  GET_PROMO_REQUEST: 'TRANSACTIONS_GET_PROMO_REQUEST',
  GET_PROMO_SUCCESS: 'TRANSACTIONS_GET_PROMO_SUCCESS',
  GET_PROMO_FAILURE: 'TRANSACTIONS_GET_PROMO_FAILURE',
  GET_PROMO_CLEAR: 'TRANSACTIONS_GET_PROMO_CLEAR',
};

export default transactionConstants;
